module.exports = __webpack_public_path__ + "img/ebook-ebook.705b219f.png";